// @ts-check
import {
  StyledEmptyStateDescription,
  StyledFilterSetsList,
  StyledList
} from './FilterSetsList.style';
import FilterSetsTable from './FilterSetsTable';
import Header from './Header';
import FilterSetForm from '../FilterSetForm';
import useListFilters from './useListFilters';
import useFilteredListData from './useFilteredListData';
import useListHandler from './useListHandler';
import DeleteConfirmation from './DeleteConfirmation/DeleteConfirmation';
import { LBButton } from '@linearb/buzz';

const FilterSetsList = ({ Context, onSelect, onClose }) => {
  const listFilters = useListFilters(Context);
  const filteredList = useFilteredListData({ Context, listFilters });

  const listHandlers = useListHandler({
    Context,
    onSelect
  });

  if (listHandlers.filterSetToDelete) {
    return (
      <DeleteConfirmation
        Context={Context}
        filterSet={listHandlers.filterSetToDelete}
        onDelete={() => listHandlers.setFilterSetToDelete(null)}
        onCancel={() => listHandlers.setFilterSetToDelete(null)}
      />
    );
  }

  if (listHandlers?.filterSetToEdit) {
    return (
      <FilterSetForm
        filterSet={listHandlers?.filterSetToEdit}
        Context={Context}
        onSubmit={() => listHandlers?.setFilterSetToEdit(null)}
        onBack={() => listHandlers?.setFilterSetToEdit(null)}
      />
    );
  }

  return (
    <StyledFilterSetsList data-cy='saved-filters-modal'>
      <Header listFilters={listFilters} />
      <StyledList>
        {listHandlers.isListEmpty ? (
          <StyledEmptyStateDescription>
            You haven’t created any filters yet. <br />
            When you do, they will appear here, along with any filters others
            share with you.
          </StyledEmptyStateDescription>
        ) : (
          <FilterSetsTable
            Context={Context}
            listHandlers={listHandlers}
            listFilters={listFilters}
            filteredList={filteredList}
          />
        )}
      </StyledList>
      {onClose && (
        <div className='flex flex-row-reverse'>
          <LBButton onClick={onClose}>Close</LBButton>
        </div>
      )}
    </StyledFilterSetsList>
  );
};

export default FilterSetsList;
